import React, { useEffect, useCallback, useState } from 'react'
import { Form, Select, Empty } from 'antd'
import { Image, Avatar, Text } from 'components/common'
import { useRules } from 'helpers'

const SelectViewers = (props) => {
    const [data, setData] = useState([])

    const onSearch = useCallback((value) => {
        const filtered = props.list.filter(entry => Object.values(entry).some(val => typeof val === "string" && val.toLowerCase().includes(value.toLowerCase())));
        setData(filtered)
    }, [props.list])

    const onSelect = useCallback(() => {
        setData(props.list)
    }, [props.list])


    useEffect(() => {
        setData(props.list)
    }, [props.list])

    return (
        <Form.Item
            {...props.labelOptions}
            label={props.label}
            name={'viewers'}
            rules={useRules(props)}
            messageVariables={{ errorKey: 'Viewers' }}>
            <Select
                showSearch={true}
                menuItemSelectedIcon={<Image src='/images/mark.svg' />}
                placeholder={'Invite to the debate'}
                onSelect={onSelect}
                onSearch={onSearch}
                mode={'multiple'}
                filterOption={false}
                className='viewersWrapper'
                dropdownClassName={props.dropdownClassName}
                notFoundContent={(
                    <Empty
                        className='ant-empty ant-empty-normal ant-empty-small'
                        image={Empty.PRESENTED_IMAGE_SIMPLE}
                        description={props.noDataText}
                    />
                )}
            >
                {data.map(item => (
                    <Select.Option key={item.id} value={item.id}>
                        <div className='invite-list flexBoxColumn'>
                            <div className='single-user flexBox'>
                                <Avatar src={item.avatar} />
                                <Text tag='p' className='PopReg const14' text={`${item.name} ${item.surname}`} />
                            </div>
                        </div>
                    </Select.Option>
                ))}
            </Select>
        </Form.Item>
    )
}

SelectViewers.defaultProps = {
    label: '',
    name: '',
    placeholder: '',
    defaultValue: '',
    required: false,
    rules: [],
    labelOptions: {},
    list: [],
    errorKey: null,
    noDataText: 'No data'
}

export default SelectViewers
